import React, { Fragment, useEffect, useRef } from 'react'
import PropTypes from 'prop-types'
import OtpInput from 'react-otp-input'
import { Button } from 'loyal-react'

const PasswordNumberConfirm = ({
  isLoading,
  passwordNumberConfirm,
  passwordNumber,
  handleChange,
  handleValidatePasswordConfirm,
  errors
}) => {
  const isValid = passwordNumberConfirm && passwordNumberConfirm.toString().length === 6 && passwordNumberConfirm === passwordNumber

  const changePassNumber = (value) => {
    handleChange({
      target: {
        name: 'passwordNumberConfirm',
        value: `${value}`.replace(/\D/g, '')
      }
    })
  }

  const passwordContainerRef = useRef()

  useEffect(() => {
    const inputs = passwordContainerRef.current.querySelectorAll('input')
    inputs.forEach((input, index) => {
      input.setAttribute('aria-label', `${index + 1}º digito`)
    })

    document.activeElement.blur()
  }, [])

  return (
    <Fragment>
      <div className='col-12 border-color-ui-3 bg-white border radius'>
        <div className='checkout-step row px-1 py-2 border-bottom border-color-ui-3 '>
          <div className='col mr-auto'>
            <h1 className='txt-title txt-font-body txt-initial color-title mr-auto'>
              Confirme a senha da central de atendimento
            </h1>
          </div>
        </div>
        <div className='col-12 border-color-ui-3'>
          <p className='mt-2'>Agora confirme a senha numérica para falar com a central de atendimento.</p>
          <div className='row'>
            <div
              ref={passwordContainerRef}
              className='col-12 col-md-6 password-numeric-box mt-2'
              aria-label='Campos de senha numérica'
            >
              <OtpInput
                name='passwordNumberConfirm'
                id='passwordNumberConfirm'
                value={passwordNumberConfirm}
                onChange={changePassNumber}
                shouldAutoFocus
                numInputs={6}
                tabIndex='0'
                focusStyle={{ outline: 0 }}
                valid={errors['PasswordConfirmValidate'] ? false : undefined}
                data-error={errors['PasswordConfirmValidate'] && errors['PasswordConfirmValidate']}
              />
            </div>
          </div>
          <div className='col-12 col-md-6 mt-2'>
            <div className='col-12 px-0 pb-2'>
              <Button
                id={'btn-password'}
                name={'btn-password'}
                className='btn btn-sm btn-featured border border-color-ui-3 mr-1'
                type='button'
                text='Salvar e continuar'
                disabled={!isValid}
                onClick={handleValidatePasswordConfirm}
                loading={isLoading}
              />
            </div>
          </div>
        </div>
      </div>
    </Fragment>
  )
}

PasswordNumberConfirm.propTypes = {
  isLoading: PropTypes.bool,
  passwordNumberConfirm: PropTypes.string,
  passwordNumber: PropTypes.string,
  handleChange: PropTypes.func.isRequired,
  handleValidatePasswordConfirm: PropTypes.func.isRequired,
  errors: PropTypes.object
}

export default PasswordNumberConfirm



// WEBPACK FOOTER //
// ./src/Participant/UraPassword/UnlockUraPassword/PasswordNumberConfirm/PasswordNumberConfirm.js